import React from 'react'
import { ArrowBackIos } from '@material-ui/icons'
import { useStyles } from './SmallScreenNavigationHeader.styles'
import { Clickable } from 'components/ui/Behaviors/Clickable'

interface ISmallScreenNavigationHeaderProps {
  onClick?: () => void
}

export const SmallScreenNavigationHeader = ({ onClick }: ISmallScreenNavigationHeaderProps) => {
  const classes = useStyles()

  return (
    <>
      {onClick ? (
        <Clickable onClick={onClick}>
          <div className={classes.root}>
            <ArrowBackIos className={classes.arrow} />
          </div>
        </Clickable>
      ) : (
        <div className={classes.root}></div>
      )}
    </>
  )
}
